import React, { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { history } from 'nallian-shared-ui/lib/config/history';
import updateIdentificationCodeTypeService from '../../services/identificationCodeTypes/updateIdentificationCodeTypeService';
import identificationCodeTypeService from '../../services/identificationCodeTypes/identificationCodeTypeService';
import TypeForm from './TypeForm';
import { COMMUNITY_DETAIL_TABS } from '../../constants';

const EditType = ({
  open,
  dispatchUpdateCommunityIdentificationCodeTypePut,
  updateCommunityIdentificationCodeTypeFetch,
  dispatchCommunityIdentificationCodeTypeGet,
  communityIdentificationCodeTypeFetch,
}) => {
  const { t } = useTranslation();
  const { id, actionId } = useParams();

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateCommunityIdentificationCodeTypePut(
        id,
        actionId,
        body,
        () =>
          history.push(
            `/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.IDENTIFICATION_CODE_TYPES}`
          ),
        t
      ),
    [id, actionId, dispatchUpdateCommunityIdentificationCodeTypePut, t]
  );

  useEffect(() => {
    if (open && id) {
      dispatchCommunityIdentificationCodeTypeGet(
        id,
        actionId,
        () =>
          history.push(
            `/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.IDENTIFICATION_CODE_TYPES}`
          ),
        t
      );
    }
  }, [id, actionId, open, t, dispatchCommunityIdentificationCodeTypeGet]);

  const defaultData = useMemo(
    () => ({
      isRequired: communityIdentificationCodeTypeFetch.value?.isRequired,
      identificationCodeTypeTag: communityIdentificationCodeTypeFetch.value?.type?.tag,
    }),
    [communityIdentificationCodeTypeFetch]
  );

  if (!open) return null;

  return (
    <TypeForm
      header={t('editType')}
      onSubmit={handleSubmit}
      submitProcessing={updateCommunityIdentificationCodeTypeFetch.pending}
      returnRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.IDENTIFICATION_CODE_TYPES}`}
      cancelRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.IDENTIFICATION_CODE_TYPES}`}
      dataLoading={communityIdentificationCodeTypeFetch.pending}
      data={defaultData}
      showRemoveButton
      editMode
    />
  );
};

EditType.propTypes = {
  dispatchUpdateCommunityIdentificationCodeTypePut: PropTypes.func.isRequired,
  updateCommunityIdentificationCodeTypeFetch: PropTypes.object.isRequired,
  dispatchCommunityIdentificationCodeTypeGet: PropTypes.func.isRequired,
  communityIdentificationCodeTypeFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditType.defaultProps = { open: false };

export default compose(
  identificationCodeTypeService,
  updateIdentificationCodeTypeService
)(EditType);
